export default __webpack_public_path__ + "media/images/missing_company_logo-1ff1d726ce8bfc470b9d9953cb9fde49.png";